import useAgentData from "@casino/legacy/client/hooks/useAgentData";
import useIsLoggedIn from "@casino/legacy/client/hooks/user/useIsLoggedIn";
import type GameThumbProps from "../GameThumbProps";

const useGameThumb = ({
  game,
  isHoverEnabled,
  hideFavourite = false,
  width,
  showGrid,
  height,
  big,
  light,
  preloadImg,
  isBadge,
  onClick,
  isMinMaxBetVisible,
  isCarousel,
  isSmallThumbnail = false,
  wide = false,
}: GameThumbProps) => {
  const { isDesktop } = useAgentData();
  const newThumbnailUrl = game.thumbUrlTab || game.thumbUrl;
  const thumb = !isSmallThumbnail ? newThumbnailUrl : game.thumbUrl;
  const isLoggedIn = useIsLoggedIn();
  const isFavouriteToggleVisible = isLoggedIn && !hideFavourite;
  return {
    game,
    thumb,
    width,
    showGrid,
    height,
    big,
    light,
    preloadImg,
    isBadge,
    isFavouriteToggleVisible,
    isHoverEnabled: isHoverEnabled && isDesktop && !onClick,
    isMinMaxBetVisible,
    isDesktop,
    isCarousel,
    wide,
  };
};

export default useGameThumb;
